import React, { useEffect, useContext, useRef, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Container, Row } from "reactstrap";
import swal from "sweetalert";
import { AppContext } from "../../context/app-context";
import API from "../../helper/API";
import { healthConditions } from "../../context/staticData";
import { checkMyDietPlan, onFinishedWebView, sendFirebaseEvent } from "../../helper/mobile";
import Feature from "./PlanDetail/Feature";
import ProFeature from "./ProPlan/Feature";
import Payment from "./PlanDetail/Payment";
import PlanCategory from "./PlanDetail/PlanCategory";
import UnlockFeature from "./PlanDetail/UnlockFeatureCard";
import ProUnlockFeature from "./ProPlan/UnlockFeatureCard";
import Header from "./PlanDetail/Header";
import GoldPlanCard from "./PlanDetail/GoldPlanCard";
import ProHeader from "./ProPlan/Header";
import WeightJourneySection from "./PlanDetail/WeightJourneySection";
import ProDietPlanCard from "./Category/ProDietPlanCard";
// import Star0 from "../../assets/images/DietPlans/Star0.png";
import Star0 from "../../assets/images/DietPlans/star53.svg";
import DietPlanWaitingScreen from "./DietPlanSuccess/DietPlanWaitingScreen";
import Unsubscribe from "./Unsubscribe";
import { compareVersions } from "../../helper";
import { PlanName } from "../../constants";
import UnAvailable from "./Unavailable";
import { openTermsAndConditionWeb } from "../../helper/mobile";

const DietPlan = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const appVersion = searchParams.get("appVersion");
  const osType = searchParams.get("osType");
  const appVersionCode = searchParams.get("appVersionCode");
  const isActivateCode = searchParams.get("isActivateCode");
  const isGoalSet = searchParams.get("isGoalSet");
  const [state, dispatch] = useContext(AppContext);
  let navigate = useNavigate();
  const [currentDietPlan, setCurrentDietPlan] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [isWaiting, setIsWaiting] = useState(false);
  const [categoryId, setCategoryId] = useState("weight_loss");
  const [selectedPlanType, setSelectedPlanType] = useState('');
  const prevPlanRef = useRef(selectedPlanType);
  const [isPlanSwitching, setIsPlanSwitching] = useState(false);
  const planBelowSwitchTimersRef = useRef([]);
  // For Android: versions below 7.0.0 see the UnAvailable screen.
  // For 7.0.0 and above, always show the new UI. iOS always uses the new UI.
  const isUnavailable =
    osType === "android" ? !compareVersions(appVersion, "7.0.0") : false;
  const isNewCards =
    osType === "android" ? compareVersions(appVersion, "7.0.0") : true;
  
  const userAppInfo = {
    appVersion: appVersion,
    osType: osType,
    token: token,
    isActivateCode: isActivateCode,
    appVersionCode: appVersionCode,
  };

  if (token) localStorage.setItem("token", token);

  localStorage.removeItem("country");

  useEffect(() => {
    if (osType === "android") {
      // Android: default to Silver plan
      setSelectedPlanType(PlanName.YEARLY_ELITE_PLAN);
    } else if (osType === "iOS") {
      // iOS: default to Gold (AI) plan
      setSelectedPlanType(PlanName.AI_PLAN);
    } else if (!isNewCards) {
      // Fallback for old/web flows
      if (compareVersions(appVersion)) {
        setSelectedPlanType(PlanName.AI_PLAN);
      } else {
        setSelectedPlanType(PlanName.SHEET_PLAN);
      }
    } else {
      setSelectedPlanType(PlanName.AI_PLAN);
    }
  }, [osType, isNewCards, appVersion]);

  // Ensure top-to-bottom visual load order during plan switching
  useEffect(() => {
    prevPlanRef.current = selectedPlanType;
  }, [selectedPlanType]);

  const forceUpdate = () => {
    swal({
      className: "swal-height-width-change",
      title: "Version too old",
      text: "This version of app is no longer supported diet plan. Please upgrade to a newer version",
      buttons: ["Close", "Upgrade"],
    }).then((willDelete) => {
      if (willDelete) {
        window.location.href = "https://drtrust360.page.link/update";
        return null;
      } else {
        onFinishedWebView();
      }
    });
  };

  const softUpdate = () => {
    swal({
      className: "swal-height-width-change",
      title: "Update your app",
      text: "This version of the app does not support newer diet plan features. Please upgrade to a newer version",
      buttons: ["Later", "Upgrade"],
    }).then((willDelete) => {
      if (willDelete) {
        window.location.href = "https://drtrust360.page.link/update";
        return null;
      }
    });
  };

  useEffect(() => {
    if (isLoading) document.body.classList.add("loading-indicator");
    else document.body.classList.remove("loading-indicator");
  }, [isLoading]);

  useEffect(() => {
    return () => {
      planBelowSwitchTimersRef.current.forEach(clearTimeout);
      planBelowSwitchTimersRef.current = [];
    };
  }, []);

  useEffect(() => {
    setIsWaiting(false);
    dispatch({
      type: "USER_DETAILS",
      payload: { isGoalSet: isGoalSet },
    });

    if (token && appVersion && osType && appVersionCode) {
      const appVersionCodeNumber = parseInt(appVersionCode);
      if (osType === "android") {
        if (appVersionCodeNumber < 84) {
          forceUpdate();
        } else if (appVersionCodeNumber >= 84 && appVersionCodeNumber < 92) {
          // softUpdate();
        }
      } else if (osType === "iOS") {
        if (appVersionCodeNumber < 95) {
          // softUpdate();
        }
      }
      dietPlanAndUserInfo();
    } else {
      swal({
        className: "swal-height-width-change",
        title: "Error",
        text: "Something went wrong",
        buttons: "Okay",
      }).then((willDelete) => {
        onFinishedWebView();
      });
    }
  }, []);

  const healthConditionsArray = (dh) => {
    let finalArr = [];
    healthConditions.forEach((obj) => {
      const findHC = dh.find((i) => i.heathConditionValue === obj.value);
      if (findHC) {
        finalArr.push({
          label: findHC.heathConditionLabel,
          value: findHC.heathConditionValue,
          isChecked: true,
        });
      } else {
        finalArr.push(obj);
      }
    });
    return finalArr;
  };

  // const checkDietPlanProgress = (userId) => {
  //   setIsLoading(true);
  //   API.get(`/user/goal/nutrition?userId=${userId}`)
  //   .then((res) => {
  //     const {planType, planStatus} = res?.data || {};
  //     const isInProgress = planType === 'AI_PLAN' && planStatus === 'PENDING'
  //     if(isInProgress) {
  //       checkMyDietPlan();
  //       setIsWaiting(true)
  //     }else
  //       getDietPlanInfo(userId);
  //   }).catch((err) => {
  //     if (
  //       err?.response?.data?.message ===
  //       "Your Diet Plan is being generated. Please check after some time. "
  //     ) {
  //       setIsWaiting(true);
  //       console.error(err.response, "err");
  //     }
  //   })
  //   .finally(() => setIsLoading(false))
  // }

  const getDietPlanInfo = (userId) => {
    setIsLoading(true);
    API.get(`/user/dietplan/?userId=${userId}`)
      .then((response) => {
        console.log("resData----------", response);
        const resData = response?.data;
        const isInProgress = resData?.planStatus === "PENDING" &&
         resData?.dietPlanType === "one_month_ai_diet_plan_autopay_subscription" &&
         resData?.assessmentCompleted;
        console.log(isInProgress)
        if (resData) {
          dispatch({
            type: "USER_DETAILS",
            payload: { dietPlanId: resData.dietPlanId },
          });
          if (resData.active) {
            const isCancelSubscription =  resData?.isCancelSubscription ?
            resData?.isCancelSubscription :
            new Date(resData?.planStartDate) < new Date("2025-06-26T00:00:00.000Z")
            setCurrentDietPlan({...resData, isCancelSubscription});
            dispatch({
              type: "EXISTING_DIETPLAN",
              payload: { ...resData },
            });
            console.log("resDATA", resData);
            if (
              resData &&
              //  &&
              // !(
              //   resData?.assessmentDetails?.healthConditions ||
              //   resData?.assessmentDetails?.preferredCuisine ||
              //   resData?.assessmentDetails?.dietaryPreference
              // )
              !resData?.assessmentCompleted &&
              (resData?.dietPlanType !== PlanName.ELITE_PLAN &&
              resData?.dietPlanType !== PlanName.YEARLY_ELITE_PLAN)
            ) {
              if (resData?.assessmentDetails?.planType) {
                dispatch({
                  type: "ASSESSMENT",
                  payload: { planType: resData?.assessmentDetails?.planType },
                });
              }

              navigate(`mandatory`);
            }
            if (isActivateCode === "true")
              navigate(`/dietPlan/couponCodeActivation`);

            if(isInProgress) {
              console.log('inside progress')
              checkMyDietPlan();
            }
          } else {
            if (isActivateCode === "true")
              navigate(`/dietPlan/couponCodeActivation`);
          }
        }
      })
      .catch((error) => {
        if (error?.response?.status === 405) {
          if (isActivateCode === "true")
            navigate(`/dietPlan/couponCodeActivation`);
        }
      })
      .finally(() => setIsLoading(false));
  };

  const dietPlanAndUserInfo = () => {
    setIsLoading(true);
    API.get("/user/basic-info").then(
      (userRes) => {
        if (userRes?.data?.id) {
          dispatch({
            type: "USER_DETAILS",
            payload: { ...userRes.data, ...userAppInfo },
          });
          setIsLoading(false);
          if (userRes?.data?.healthConditions) {
            let returnHelath = healthConditionsArray(
              userRes.data.healthConditions
            );
            dispatch({
              type: "HEALTH_CONDITIONS",
              payload: returnHelath,
            });
          }
          getDietPlanInfo(userRes.data.id);
        }
      },
      (err) => {
        if (
          err?.response?.data?.message ===
          "Your Diet Plan is being generated. Please check after some time. "
        ) {
           setIsLoading(false);
           checkMyDietPlan();
          // setIsWaiting(true);

          //  navigate(`analyzing`);

          // swal({
          //   className: "swal-height-width-change",
          //   title: "Your Diet Plan is being generated.",
          //   text: " Please check after some time. ",
          //   buttons: "Done"
          // })
          console.log(err.response, "err");
        }
      }
    );
  };

  const updatePlanType = (plan) => {
    const isSilverTarget =
      plan === PlanName.ELITE_PLAN || plan === PlanName.YEARLY_ELITE_PLAN;

    planBelowSwitchTimersRef.current.forEach(clearTimeout);
    planBelowSwitchTimersRef.current = [];

    setSelectedPlanType(plan);

    const needsScroll =
      typeof window !== "undefined" &&
      isSilverTarget &&
      (window.scrollY || window.pageYOffset || 0) > 0;

    // When switching to Pro Lite from lower on the page: scroll first. If we set
    // `.plan-below` to opacity 0 during smooth scroll, the viewport shows empty area
    // and it reads as a white flash — defer the hide until after scroll settles.
    if (needsScroll) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      const afterScrollMs = 480;
      const t1 = window.setTimeout(() => {
        setIsPlanSwitching(true);
        const t2 = window.setTimeout(() => {
          setIsPlanSwitching(false);
        }, 260);
        planBelowSwitchTimersRef.current.push(t2);
      }, afterScrollMs);
      planBelowSwitchTimersRef.current.push(t1);
      return;
    }

    setIsPlanSwitching(isSilverTarget);
    if (isSilverTarget) {
      const t = window.setTimeout(() => setIsPlanSwitching(false), 260);
      planBelowSwitchTimersRef.current.push(t);
    }
  };

  const handleOnClick = () => {
    sendFirebaseEvent('diet_plan_view_click', 'click_event', 'diet_plan_status');
    checkMyDietPlan();
  }

  return (
    <>
      {!isLoading && (
        <div>
          {isWaiting ? (
            <DietPlanWaitingScreen />
          ) : currentDietPlan?.active ? (
            <div className="dark">
            <Container fluid className="dietplan-page-container">
              <Row>
                <ProHeader />
              </Row>

              <>
                <div onClick={handleOnClick} className="dietplan-card-link">
                  <ProDietPlanCard dietPlan={currentDietPlan} />
                </div>
                <div className="mb-3">
                  <div className="text-center text-uppercase fw-bold d-flex align-items-center justify-content-center">
                    <img
                      className="star-img"
                      src={Star0}
                      alt="star"
                      loading="lazy"
                      height="100%"
                      width="100%"
                    />
                    <div className="free-diet-plan-links">
                    PRO BENEFITS Of {(currentDietPlan.dietPlanType !== PlanName.ELITE_PLAN && currentDietPlan.dietPlanType !== PlanName.YEARLY_ELITE_PLAN) ? 'Diet Plan' : 'Lite Plan'}
                    </div>
                    <img
                      className="star-img"
                      src={Star0}
                      alt="star"
                      loading="lazy"
                      height="100%"
                      width="100%"
                    />
                  </div>
                </div>
              </>
              <ProFeature dietPlan={currentDietPlan}/>
              <ProUnlockFeature />
              <WeightJourneySection />
              <Unsubscribe subscriptionId={currentDietPlan?.subscriptionId} isAutoPayCancelled={currentDietPlan?.isAutoPayCancelled} isCancelSubscription={currentDietPlan?.isCancelSubscription} />
              <div className="gold-plan-disclaimer mt-3">
                <p className="gold-plan-disclaimer-text">
                  *we will be using your health data to create and curate personalised ai recommendation for you
                </p>
                <a
                  className="gold-plan-tnc-text"
                  href="https://terms.drtrust360.com/"
                  target="_blank"
                  rel="noreferrer"
                  onClick={(e) => {
                    e.preventDefault();
                    openTermsAndConditionWeb();
                  }}
                >
                  Terms &amp; Conditions
                </a>
              </div>
            </Container>
            </div>
          ) : ( <>
            { isUnavailable ? <UnAvailable /> : <>
              <Container fluid className="dietplan-page-container">
               <Row>
                 <Header selectedPlanType={selectedPlanType} />
               </Row>
               <div className={`plan-below ${isPlanSwitching ? "plan-below--switching" : ""}`}>
                 <GoldPlanCard selectedPlanType={selectedPlanType} />
               </div>
              {/* For new plan-based design, we hide the old goal-scrolling
                  and testimonial sections for both iOS and Android. */}
               </Container>

               {/* Old payment UI permanently disabled */}
               {false && !isNewCards && osType !== "iOS" && !currentDietPlan?.active && (
                 <Payment
                   appVersion={appVersion}
                   categoryId={categoryId}
                   selectedPlanType={selectedPlanType}
                   updatePlanType={updatePlanType}
                   setCategoryId={setCategoryId}
                 />
               )}
               {(isNewCards || osType === "iOS") && !currentDietPlan?.active && (
                 <div className="diet-payment-footer">
                   <Payment
                     appVersion={appVersion}
                     categoryId={categoryId}
                     selectedPlanType={selectedPlanType}
                     updatePlanType={updatePlanType}
                     setCategoryId={setCategoryId}
                   />
                 </div>
               )}
             </>}
            </>
          )}
          </div>
      )}
    </>
  );
};

export default DietPlan;
